module.exports = __webpack_public_path__ + "img/tabs1(4).c70dc09f.png";